export default __webpack_public_path__ + "static/media/pexels-hannah-smid-3914608.ba5faef8.jpg";